import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { masterCategories } from "../mockMasters";
import { styleBg } from "../../../../common/Models/Validations";

export default function MasterCategoryTabs({ categoryId, onChange }) {
  const activeIndex = masterCategories.findIndex((c) => c.id === categoryId);
  const currentIndex = activeIndex >= 0 ? activeIndex : 0;

  const handleChange = (event, newValue) => {
    const next = masterCategories[newValue];
    if (next?.id) onChange?.(next.id);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
      <Tabs
        value={currentIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="master data categories"
      >
        {masterCategories.map((category, index) => (
          <Tab 
            key={category.id} 
            label={category.label}
            sx={{ minWidth: 180, ...styleBg(index, currentIndex) }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
